import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  user: any = {};
  public messageSource = new BehaviorSubject<any>(this.user);
  $user = this.messageSource.asObservable();


  getUserInfoInStorage(): object {
    return JSON.parse(localStorage.getItem('createuserinfo'));
  }

  placeUserInfoInStorage(user: any) {
    localStorage.setItem('createuserinfo', JSON.stringify(user));
  }

  getCommercialAcFlag(): object {
    return JSON.parse(localStorage.getItem('isCommercialAccount'));
  }

  setCommercialAcFlag(value: any) {
    localStorage.setItem('isCommercialAccount', JSON.stringify(value));
  }

  updateUser(user: any) {
    this.messageSource.next(user);
  }

  clearUser() {
    this.messageSource.next('');
  }
}
